import React, { useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Footer from "../Footer";
import "./src/operaciones.css";

import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Button } from 'semantic-ui-react'
import { Image } from 'semantic-ui-react'

import { Dashboard, PeopleAlt, MenuOutlined, Storage, TimelineOutlined, NotificationImportantOutlined, AccountTreeOutlined } from "@material-ui/icons";

import imgnotificaciones from "./src/img/notificaciones.webp";
import imgoperaciones from "./src/img/operaciones.jpg";
import imgsolicitudes from "./src/img/solicitudes.jpg";
import imgconvenios from "./src/img/convenios.webp";
import imgreportes from "./src/img/reportes.jpg";

import OperacionesReporte from "../Pagos/OperacionesReporte";
import OperacionesReporteCuotas from "../Pagos/Cuotas";
import ReporteInscritos from "../Informes/ReporteInscritos";
import CreateConvenios from "../Convenios/CreateConvenios";
import CreateSolicitudes from "../Convenios/CreateSolicitudes"
import EntradaAdministrador from "../Convenios/EntradaConvenios"
import ReporteBanrural from "../Informes/ReporteBanrural";
import ListaConvenios from "../Convenios/ListaConvenios";
import CargaInscripcion from "../Pagos/CargaInscripcion";
import Notificaciones from "../Pagos/Notificaciones";
import Exoneraciones from "../Pagos/Exoneraciones";
import SaldosReporte from "../Pagos/SaldosReporte";
import OperacionesR from "../Pagos/OperacionesR";
import Cargar from "../Pagos/Carga";
import ListaSolicitudes from "../Convenios/ListaSolicitudes";
import DetalleConvenios from "../Convenios/DetalleConvenios";
import UsersList from "./AdministrarUsuarios/UsersList";


export default observer(function OperacionesHome() {

    const [isOpen, setIsOpen] = useState(true);
    const toggleMenu = () => { setIsOpen(!isOpen) };

    const {
        userStore: { user, logout, isLoggedIn, roles },
        modalStore,
    } = useStore();
    
    const [hasConvenio, setHasConvenio] = useState(false);
    const location = useLocation();
    const [permiso, setPermiso] = useState([""]);
    
    useEffect(() => {
        let permisos: any[] = [];
        roles()?.map((item: any) => { permisos.push(item) })
        setPermiso(permisos);
        const url = window.location.href.toLowerCase();
        const hasWordC =
            url.includes("conveniospanes") ||
            url.includes("crearsolicitud") ||
            url.includes("solicitudescreadas") ||
            url.includes("crearconvenio") ||
            url.includes("convenioscreados") ||
            url.includes("convenios") ||
            url.includes("exoneracioness") ||
            url.includes("adminusuarios") ||
            url.includes("aprobacionexoneraciones") ||
            url.includes("reporteinscritosp") ||
            url.includes("reportebanruralp") ||
            url.includes("reportes") ||
            url.includes("reporteo") ||
            url.includes("operacionm") ||
            url.includes("cargapagos") ||
            url.includes("Cuotass") ||
            url.includes("notificacionesr"); 
        setHasConvenio(hasWordC);
        hasWordC ? setIsOpen(false) : setIsOpen(true);
    }, [location]);

    const modconv = (p: any) => (
        <Tooltip id="button-tooltip" {...p}>
            Códigos Institucionales
        </Tooltip>
    );

    const modsol = (p: any) => (
        <Tooltip id="button-tooltip" {...p}>
            Exoneraciones
        </Tooltip>
    );

    const modadminuser = (p: any) => (
        <Tooltip id="button-tooltip" {...p}>
            Administrar Usuarios
        </Tooltip>
    );

    const modrepo = (p: any) => (
        <Tooltip id="button-tooltip" {...p}>
            Reportes
        </Tooltip>
    );

    const modop = (p: any) => (
        <Tooltip id="button-tooltip" {...p}>
            Operaciones
        </Tooltip>
    );

    const modnoti = (p: any) => (
        <Tooltip id="button-tooltip" {...p}>
            Notificaciones
        </Tooltip>
    );

    /* ---------------------------------------------------- */
    const CargaP = () => (
        <div key="cargar">
            <Cargar />
        </div>
    );

    const Cuotas = () => (
        <div key="cuotas">
            <OperacionesReporteCuotas />
        </div>
    );

    /* ---- Convenios ---- */
    const ConveniosPanes = () => (
        <div key="EntradaAdministrador">
            <EntradaAdministrador />
        </div>
    )

    const CrearSolicitud = () => (
        <div key="crearsolicitudes">
            <CreateSolicitudes />
        </div>
    )

    const SolicitudesCreadas = () => (
        <div key="llistasolicitudes">
            <ListaSolicitudes />
        </div>
    )

    const CrearConvenio = () => (
        <div key="crearconvenios">
            <CreateConvenios />
        </div>
    )

    const ConveniosCreados = () => (
        <div key="Listaconvenios">
            <ListaConvenios />
        </div>
    )

    /* ---- Exoneraciones ---- */
    const Exoneracioness = () => (
        <div>
            <Exoneraciones />
        </div>
    );

    const AprobacionExoneraciones = () => (
        <div>
            <Notificaciones />
        </div>
    );

    const NotificacionesR = () => (
        <div>
            {/* nuevo conponente para notifcaciones */}
        </div>
    );

    /* -- Reportes -- */
    const ReporteInscritosP = () => (
        <div>
            <ReporteInscritos />
        </div>
    );

    const ReporteBanruralP = () => (
        <div>
            <ReporteBanrural />
        </div>
    );

    const ReporteS = () => (
        <div>
            <SaldosReporte />
        </div>
    );

    const ReporteO = () => (
        <div>
            <OperacionesR />
        </div>
    );

    /* -- Operaciones -- */
    const operacionM = () => (
        <div>
            <OperacionesReporte />
        </div>
    );

    /* -- Administrar usuarios -- */
    const adminUsuarios = () => (
        <div>
            <UsersList />
        </div>
    )

    

    return (

        <>


            <Container className={`content-mid-fluid-area operaciones-area ${hasConvenio ? 'op-convenio-path' : 'op-sinconvenio'}`}>

                <div className="title-area">
                    <h2>Operaciones</h2>
                </div>

                <style>{`.op-menu { width: ${isOpen ? '100%' : '90px'}`}</style>
                <div className={`op-menu op-menu-area ${isOpen ? 'op-open' : 'op-closed'}`}>
                    <Button circular color='facebook' icon='plus' className="op-button" onClick={toggleMenu} />
                    <Row className="operaciones-content-menu">
                        <Container className={`op-vertical-menu-op ${isOpen ? 'op-menu-block-none' : 'op-menu-block-flex'}`}>

                            <Col className="op-vertical-icon">
                                <OverlayTrigger
                                    placement="right"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={modconv}
                                    
                                >
                                    { permiso.includes ("Crear Convenio") ?
                                        
                                            <Link to={"/home/operaciones/:id/ConveniosPanes"} >
                                                <Dashboard />
                                            </Link>
                                        
                                    :
                                        <Link to={"/home/operaciones/:id/ConveniosPanes"} style={{ opacity: "0.4", pointerEvents: "none" }} >
                                            <Dashboard />
                                        </Link>
                                    }

                                </OverlayTrigger>
                            </Col>

                            <Col className="op-vertical-icon">
                                <OverlayTrigger
                                    placement="right"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={modsol}
                                    key="crear-22"
                                >
                                    {permiso.includes("Exoneracions") ?
                                        <Link to="/home/operaciones/:id/Exoneracioness" >
                                            <Storage />
                                        </Link>
                                    :
                                        <Link to="/home/operaciones/:id/Exoneracioness" style={{ opacity: "0.4", pointerEvents: "none" }} >
                                            <Storage />
                                        </Link>
                                    }
                                </OverlayTrigger>
                            </Col>

                            <Col className="op-vertical-icon" key="crear-3">
                                <OverlayTrigger
                                    placement="right"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={modadminuser}
                                >
                                    {permiso.includes("Exoneracions") ?
                                        <Link to="/home/operaciones/:id/adminUsuarios" >
                                            <PeopleAlt />
                                        </Link>
                                    :
                                        <Link to="/home/operaciones/:id/adminUsuarios" style={{ opacity: "0.4", pointerEvents: "none" }}>
                                            <PeopleAlt />
                                        </Link>
                                    }
                                </OverlayTrigger>
                            </Col>

                            <Col className="op-vertical-icon" key="crear-4">
                                <OverlayTrigger
                                    placement="right"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={modrepo}
                                >
                                    {permiso.includes("Reporte Inscritos") ?
                                        <Link to="/home/operaciones/:id/ReporteInscritosP">
                                            <TimelineOutlined />
                                        </Link>
                                    :
                                        <Link to="/home/operaciones/:id/ReporteInscritosP" style={{ opacity: "0.4", pointerEvents: "none" }}>
                                            <TimelineOutlined />
                                        </Link>
                                    }
                                </OverlayTrigger>
                            </Col>

                            <Col className="op-vertical-icon" key="crear-5">
                                <OverlayTrigger
                                    placement="right"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={modop}
                                >
                                    {permiso.includes("Modificar Operaciones") ?
                                        <Link to={"/home/operaciones/:id/operacionM"}>
                                            <AccountTreeOutlined />
                                        </Link>
                                    :
                                        <Link to={"/home/operaciones/:id/operacionM"} style={{ opacity: "0.4", pointerEvents: "none" }}>
                                            <AccountTreeOutlined />
                                        </Link>
                                    }
                                </OverlayTrigger>
                            </Col>

                            <Col className="op-vertical-icon" key="crear-6">
                                <OverlayTrigger
                                    placement="right"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={modnoti}
                                >
                                    {permiso.includes("Notificaciones") ?
                                        <Link to="/home/operaciones/:id/NotificacionesR">
                                            <NotificationImportantOutlined />
                                        </Link>
                                    :
                                        <Link to="/home/operaciones/:id/NotificacionesR" style={{ opacity: "0.4", pointerEvents: "none" }}>
                                            <NotificationImportantOutlined />
                                        </Link>
                                    }
                                </OverlayTrigger>
                            </Col>

                        </Container>

                        <div className={`op-blocks-content ${isOpen ? 'op-menu-block-flex' : 'op-menu-block-none'}`}>

                            <Col className="op-grid-section" sm={12} md={4} key="crear-7">
                                {permiso.includes("Crear Convenio") ?
                                    <Link onClick={() => setIsOpen(false)} to={"/home/operaciones/:id/ConveniosPanes"} style={{ backgroundImage: `url(${imgconvenios})` }}>
                                        <Dashboard />
                                        <h2>Códigos Institucionales</h2>
                                        <span>VER MAS</span>
                                        <div className="image-filter filter-1"></div>
                                    </Link>
                                :
                                    <Link to={"/home/operaciones/:id/ConveniosPanes"} style={{ backgroundImage: `url(${imgconvenios})`, opacity: "0.2", pointerEvents: "none" }}>
                                        <Dashboard />
                                        <h2>Códigos Institucionales</h2>
                                        <span>NO CUENTA CON PERMISOS NECESARIOS PARA ACCEDER</span>
                                        <div className="image-filter filter-1"></div>
                                    </Link>
                                }
                            </Col>

                            <Col className="op-grid-section" sm={12} md={4} key="crear-8">
                                {permiso.includes("Exoneracions") ?
                                    <Link onClick={() => {setIsOpen(false)}} to={"/home/operaciones/:id/Exoneracioness"} style={{ backgroundImage: `url(${imgsolicitudes})` }}>
                                        <Storage />
                                        <h2>Exoneraciones</h2>
                                        <span>VER MAS</span>
                                        <div className="image-filter filter-2"></div>
                                    </Link>
                                :
                                    <Link to={"/home/operaciones/:id/Exoneracioness"} style={{ backgroundImage: `url(${imgsolicitudes})`, opacity: "0.2", pointerEvents: "none" }}>
                                        <Storage />
                                        <h2>Exoneracione</h2>
                                        <span>NO CUENTA CON PERMISOS NECESARIOS PARA ACCEDER</span>

                                        <div className="image-filter filter-2"></div>
                                    </Link>
                                }
                            </Col>

                            <Col className="op-grid-section" sm={12} md={4} key="crear-9">
                                {permiso.includes("Exoneracions") ?
                                    <Link onClick={() => {setIsOpen(false)}} to={"/home/operaciones/:id/adminUsuarios"} style={{ backgroundImage: `url(${imgsolicitudes})` }}>
                                        <PeopleAlt />
                                        <h2>Administrar Usuarios</h2>
                                        <span>VER MAS</span>
                                        <div className="image-filter filter-2"></div>
                                    </Link>
                                :
                                    <Link to={"/home/operaciones/:id/adminUsuarios"} style={{ backgroundImage: `url(${imgsolicitudes})`, opacity: "0.2", pointerEvents: "none" }}>
                                        <PeopleAlt />
                                        <h2>Administrar Usuarios</h2>
                                        <span>NO CUENTA CON PERMISOS NECESARIOS PARA ACCEDER</span>

                                        <div className="image-filter filter-2"></div>
                                    </Link>
                                }
                            </Col>

                            <Col className="op-grid-section" sm={12} md={4} key="crear-10">
                                {permiso.includes("Reporte Inscritos") ?

                                    <Link to={"/home/operaciones/:id/ReporteInscritosP"} style={{ backgroundImage: `url(${imgreportes})` }}>
                                        <TimelineOutlined />
                                        <h2>Reportes</h2>
                                        <span>VER MAS</span>
                                        <div className="image-filter filter-3"></div>
                                    </Link>
                                    :
                                    <Link onClick={() => setIsOpen(false)} to={"/home/operaciones/:id/ReporteInscritosP"} style={{ backgroundImage: `url(${imgreportes})`, opacity: "0.2", pointerEvents: "none" }}>
                                        <TimelineOutlined />
                                        <h2>Reportes</h2>
                                        <span>NO CUENTA CON PERMISOS NECESARIOS PARA ACCEDER</span>
                                        <div className="image-filter filter-3"></div>
                                    </Link>
                                }
                            </Col>

                            <Col className="op-grid-section" sm={12} md={4} key="crear-11">
                                {permiso.includes("Modificar Operaciones") ?

                                    <Link to={"/home/operaciones/:id/operacionM"} style={{ backgroundImage: `url(${imgoperaciones})` }}>
                                        <AccountTreeOutlined />
                                        <h2>Operaciones</h2>
                                        <span>VER MAS</span>
                                        <div className="image-filter filter-4"></div>
                                    </Link>
                                    :
                                    <Link onClick={() => setIsOpen(false)} to={"/home/operaciones/:id/operacionM"} style={{ backgroundImage: `url(${imgoperaciones})`, opacity: "0.2", pointerEvents: "none" }}>
                                        <AccountTreeOutlined />
                                        <h2>Operaciones</h2>
                                        <span>NO CUENTA CON PERMISOS NECESARIOS PARA ACCEDER</span>
                                        <div className="image-filter filter-4"></div>
                                    </Link>
                                }

                            </Col>

                            <Col className="op-grid-section" sm={12} md={4} key="crear-12">
                                {permiso.includes("Notificaciones") ?

                                    <Link onClick={toggleMenu} to={"/home/operaciones/:id/NotificacionesR"} style={{ backgroundImage: `url(${imgnotificaciones})` }}>
                                        <NotificationImportantOutlined />
                                        <h2>Notificaciones</h2>
                                        <span>VER MAS</span>
                                        <div className="image-filter filter-5"></div>
                                    </Link>
                                    :
                                    <Link onClick={toggleMenu} to={"/home/operaciones/:id/NotificacionesR"} style={{ backgroundImage: `url(${imgnotificaciones})`, opacity: "0.2", pointerEvents: "none" }}>
                                        <NotificationImportantOutlined />
                                        <h2>Notificaciones</h2>
                                        <span>NO CUENTA CON PERMISOS NECESARIOS PARA ACCEDER</span>
                                        <div className="image-filter filter-5"></div>
                                    </Link>
                                }
                            </Col>


                        </div>
                    </Row>
                </div>

                {/* <MenuOperaciones /> */}

                <div className={`content-operaciones-interno `}>

                    {roles()?.map((rol: any) => {
                        

                        if (rol == "Cargo Pagos") {
                            return <Route
                                key="cargaP"
                                path="/home/operaciones/cargapagos/:id"
                                exact
                                component={CargaP} />;
                        }

                        if (rol == "Cuotas") {
                            return <Route
                                key="cuotas"
                                path="/home/operaciones/:id/Cuotass"
                                exact
                                component={Cuotas} />;
                        }

                        /* -- Reportes -- */
                        if (rol == "Reporte Inscritos") {
                            return (
                                <Route
                                    key="carga-1"
                                    path="/home/operaciones/:id/ReporteInscritosP"
                                    exact
                                    component={ReporteInscritosP}
                                />
                            );
                        }

                        if (rol == "Reporte Pagos") {
                            return (
                                <Route
                                key="carga-12"
                                    path="/home/operaciones/:id/ReporteBanruralP"
                                    exact
                                    component={ReporteBanruralP}
                                />
                            );
                        }

                        if (rol == "Reporte Saldos") {
                            return (
                                <Route
                                key="carga-13"
                                    path="/home/operaciones/:id/ReporteS"
                                    exact
                                    component={ReporteS}
                                />
                            );
                        }

                        if (rol == "Reporte movimientos") {
                            return (
                                <Route
                                key="carga-14"
                                    path="/home/operaciones/:id/ReporteO"
                                    exact
                                    component={ReporteO}
                                />
                            );
                        }

                        if (rol == "Modificar Operaciones") {
                            return (
                                <Route
                                key="carga-15"
                                    path="/home/operaciones/:id/operacionM"
                                    exact
                                    component={operacionM}
                                />
                            );
                        }

                        // --- EXONERACIONES --- //
                        if (rol == "Exoneracions") {
                            return (
                                <div key="uno">
                                    <Route
                                         key="carga-16"
                                        path="/home/operaciones/:id/Exoneracioness"
                                        exact
                                        component={Exoneracioness}
                                    />
                                    <Route
                                        key="carga-17"
                                        path="/home/operaciones/:id/adminUsuarios"
                                        exact
                                        component={adminUsuarios}
                                        />
                                    <Route
                                         key="carga-18"
                                        path="/home/operaciones/:id/AprobacionExoneraciones"
                                        exact
                                        component={AprobacionExoneraciones}
                                    />
                                </div>
                            );
                        }

                        // --- CONVENIOS --- //
                        if (rol == "Crear Convenio") {
                            return (
                                <div key="dos">
                                    <Route
                                        key="carga-20"
                                        path="/home/operaciones/:id/ConveniosPanes"
                                        exact
                                        component={ConveniosPanes}
                                    />
                                    <Route
                                         key="carga-21"
                                        path="/home/operaciones/:id/CrearSolicitud"
                                        exact
                                        component={CrearSolicitud}
                                    />
                                    <Route
                                        key="carga-22"
                                        path="/home/operaciones/:id/SolicitudesCreadas"
                                        exact
                                        component={SolicitudesCreadas}
                                    />
                                    <Route
                                         key="carga-23"
                                        path="/home/operaciones/:id/CrearConvenio"
                                        exact
                                        component={CrearConvenio}
                                    />
                                    <Route
                                         key="carga-24"
                                        path="/home/operaciones/:id/ConveniosCreados"
                                        exact
                                        component={ConveniosCreados}
                                    />

                                    <Route
                                        key="carga-25"
                                        path="/home/operaciones/convenios/:id"
                                        exact
                                        component={DetalleConvenios}
                                    />
                                </div>
                            )
                        }


                    })}

                </div>

            </Container>

            <Footer />


        </>
    )

})